import { Box } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalHome from './PortalHome';
import TravelBuddyShell from './travel-buddy/TravelBuddyShell';
import { Dashboard } from './travel-buddy/pages/Dashboard';
import { TripDetail } from './travel-buddy/pages/TripDetail';
import { TemplatesPage } from './travel-buddy/pages/TemplatesPage';
import { SettingsPage } from './travel-buddy/pages/SettingsPage';
import CryptoTaxFinland from './views/CryptoTaxFinland';

function isTravelBuddyHost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.startsWith('travelbuddy.');
}

const travelBuddyRoutes = (
  <>
    <Route index element={<Dashboard />} />
    <Route path="trip/:tripId" element={<TripDetail />} />
    <Route path="templates" element={<TemplatesPage />} />
    <Route path="settings" element={<SettingsPage />} />
  </>
);

export default function App() {
  const tbHost = isTravelBuddyHost();

  if (tbHost) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/travel-buddy" replace />} />
        <Route path="/travel-buddy" element={<TravelBuddyShell />}>
          {travelBuddyRoutes}
        </Route>
        <Route path="*" element={<Navigate to="/travel-buddy" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<PortalHome />} />
      <Route path="/travel-buddy" element={<TravelBuddyShell />}>
        {travelBuddyRoutes}
      </Route>
      <Route
        path="/crypto-tax-fi"
        element={
          <Box minH="100vh" bg="#0A0A0A" color="gray.100">
            <CryptoTaxFinland />
          </Box>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
